export default function (state = false, action) {
	switch (action.type) {
    case 'ZOOM_VIDEO_MODAL':
      return true

    case 'UNZOOM_VIDEO_MODAL':
      return false
    default:
      return state;
	}
}
